export default __webpack_public_path__ + "static/allHands_Roach-4-2c4abb0243c4a4346bfb935cf89a25d3.jpg";